import React from "react";

import { useStyles } from "./styles";

interface TabsProps {
    activeIndex?: number;
    menus?: string[];
    children?: React.ReactNode;
    activeColor?: string;
    inactiveColor?: string;
    setActive?: (index: number) => void;
    customHeader? : React.ReactNode;
};

export const Tabs = (props?: TabsProps) => {
    const classes = useStyles();

    return (
        <div className={classes.container}>

            {
                props?.customHeader ? props?.customHeader : 
                <div className={classes.labelContainer}>
                    {
                        props?.menus?.map((title: string, index: number) => (
                            <a href="#" className={props?.activeIndex === index ? classes.labelSelected : classes.label} onClick={() => props?.setActive(index)}>
                                {title}
                            </a>
                        ))
                    }
                </div>
            }
            

            {props?.children}

        </div>
    );
}